





import {apiV1AdminNewsPath, apiV1AdminNewsIndexPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostNew from '@/components/admin/PostNew'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm
  }
})
export default class NewsNew extends PostNew {
  path = 'news'
  createPath = apiV1AdminNewsIndexPath()

  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminNewsPath('new')
    return super.mounted()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'ニュース一覧',
        to: '/admin/news',
        exact: true
      },
      {
        text: 'ニュース新規作成'
      }
    ]
  }
}
